import styled from 'styled-components';

interface Flex {
	$justify?: string;
	$direction?: 'row' | 'column' | 'column-reverse';
	$height?: string;
	$width?: string;
	$top?: string;
	$bottom?: string;
	$position?: string;
	$alignItems?: string;
	$padding?: string;
	$margin?: string;
	$gap?: string;
	$cursor?: string;
	$color?: string;
	$wrap?: string;
	$minHeight?: string;
  $overflow?: string;
  $background?: string;
}

export const Flex = styled.div<Flex>`
	display: flex;
	flex-direction: ${props => props.$direction || 'row'};
	justify-content: ${props => props.$justify || 'initial'};
	flex-wrap: ${props => props.$wrap || 'nowrap'};
	height: ${props => props.$height || 'initial'};
	align-items: ${props => props.$alignItems || 'initial'};
	padding: ${props => props.$padding || 'initial'};
	margin: ${props => props.$margin || 'initial'};
	gap: ${props => props.$gap || 'initial'};
	width: ${props => props.$width || 'initial'};
	top: ${props => props.$top || 'initial'};
	bottom: ${props => props.$bottom || 'initial'};
	position: ${props => props.$position || 'initial'};
	cursor: ${props => props.$cursor || 'initial'};
	min-height: ${props => props.$minHeight || 'initial'};
	background: ${props => props.$background || 'transparent'};
`;
